import React, { useContext } from "react";
import authFetch from "../../authFetch";
import T from "../../i18n/translations";
import { ExpenseForm } from "../finance/expenses/ExpensesModule";
import Modal from "../../shared/Modal";
import PlatformCtx from "../../state/PlatformCtx";
import { getTaxonomyEntry } from "../../permissions/checks";

function TaskExpenseModal({state,dispatch,task,onClose,onUpdate}){
  const API=typeof window!=="undefined"?window.location.origin:"";
  const isRTL=state.lang==="ar";
  const t=T[state.lang]||T.en;
  const {users=[],locations=[],expenseCats=[],vehicles=[],projects=[],staff=[]}=state;
  const platformCtx=useContext(PlatformCtx);

  /* Phase 5.1 — four-step expense default resolver per plan §2.5.
     1. Task's own taxonomy entry default
     2. Parent entry's default (for leaf Facility entries)
     3. Module-config legacy fallback (facilityConfig / groceryConfig)
     4. Empty — user must pick at submission time */
  const resolveExpenseDefault=()=>{
    if(task.taskTypeId){
      const entry=getTaxonomyEntry(state,platformCtx,task.taskTypeId);
      if(entry?.defaultExpenseCatId)return{catId:entry.defaultExpenseCatId,subId:entry.defaultExpenseSubId||""};
      if(entry?.parent){
        const parent=getTaxonomyEntry(state,platformCtx,entry.parent);
        if(parent?.defaultExpenseCatId)return{catId:parent.defaultExpenseCatId,subId:parent.defaultExpenseSubId||""};
      }
    }
    const facConfig=state.facilityConfig||{};
    const grocConfig=state.groceryConfig||{};
    if(task.sourceModule==="Facility")return{catId:facConfig.defaultExpenseCatId||"",subId:facConfig.defaultExpenseSubId||""};
    if(task.sourceModule==="Household"||task.taskType==="grocery_run")return{catId:grocConfig.defaultExpenseCatId||"",subId:grocConfig.defaultExpenseSubId||""};
    return{catId:"",subId:""};
  };
  const moduleDefaults=resolveExpenseDefault();

  const moduleLabel=task.sourceModule?((state.platformModuleNames||{})[task.sourceModule]||task.sourceModule):"";

  return(
    <Modal><div className="stf-detail-overlay" style={{zIndex:1100}} onClick={onClose}>
      <div className="stf-detail-sheet" onClick={e=>e.stopPropagation()}>
        <div className="stf-detail-handle"/>
        <div className="stf-detail-header">
          <div style={{flex:1,minWidth:0}}>
            <div className="stf-detail-title">{isRTL?"تسجيل مصروف":"Submit Expense"}</div>
            <div className="stf-detail-sub" style={{wordBreak:"break-word"}}>{isRTL?"المهمة":"Task"}: {task.title}{moduleLabel?` · ${moduleLabel}`:""}</div>
          </div>
          <button className="stf-detail-close" onClick={onClose}>&#10005;</button>
        </div>
        <div className="stf-detail-body">
          <ExpenseForm
            cats={expenseCats} locations={locations} users={users} vehicles={vehicles} projects={projects} staff={staff}
            defaultUser={state.currentUser?.id||"u1"} currentUser={state.currentUser}
            defaultCatId={moduleDefaults.catId} defaultSubId={moduleDefaults.subId}
            defaultLocId={task.locId||""}
            compact
            t={t} lang={state.lang} wsKey={state.wsKey}
            onCancel={onClose}
            onSave={async(expense)=>{
              /* Complete the task via API with expense data — API creates the expense record */
              try{
                const r=await authFetch(`${API}/api/tasks`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({
                  action:"transition",ws_key:state.wsKey,task_id:task.id,new_status:"completed",
                  actor_id:state.currentUser?.id||"",actor_name:state.currentUser?.name||"",
                  expense_data:{amount:expense.amount,notes:expense.notes,loc_id:expense.locId||task.locId||null,
                    cat_id:expense.catId||null,sub_id:expense.subId||null,
                    invoice_name:expense.invoiceName||null,invoice_url:expense.invoiceUrl||null},
                })});
                const j=await r.json();
                if(j.ok&&j.patch){
                  dispatch({type:"UPDATE_TASK",id:task.id,patch:j.patch});
                  onUpdate({...task,...j.patch});
                  /* Reverse sync linked module records */
                  const ctx=task.contextPayload||{};
                  if(task.sourceModule==="Facility"&&ctx.maintenanceId)dispatch({type:"UPDATE_MAINT",id:ctx.maintenanceId,patch:{status:"completed"}});
                  if((task.taskType==="grocery_run"||task.sourceModule==="Household")&&ctx.groceryIds)(ctx.groceryIds||[]).forEach(gId=>dispatch({type:"UPDATE_GROCERY",id:gId,patch:{status:"completed"}}));
                  (task.linkedEntities||[]).forEach(le=>{
                    if(le.type==="grocery")dispatch({type:"UPDATE_GROCERY",id:le.id,patch:{status:"completed"}});
                    if(le.type==="maintenance")dispatch({type:"UPDATE_MAINT",id:le.id,patch:{status:"completed"}});
                  });
                }
              }catch(e){console.error(e);}
              onClose();
            }}
          />
        </div>
      </div>
    </div></Modal>
  );
}

export default TaskExpenseModal;
